export const getOverrideStatus = (expiration: string): 'Expired' | 'Active' => {
  return Date.parse(expiration) < Date.now() ? 'Expired' : 'Active';
};
